module.exports = __webpack_public_path__ + "png/quick-registration-coin-1.png?9e5b54f3a27d47bcdc723574e8bf13cb";